import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/common.json";
import de from "./locales/de/common.json";
import nl from "./locales/nl/common.json";
import fr from "./locales/fr/common.json";
import it from "./locales/it/common.json";
import es from "./locales/es/common.json";

import enAuth from "./locales/en/auth.json";
import deAuth from "./locales/de/auth.json";
import nlAuth from "./locales/nl/auth.json";
import frAuth from "./locales/fr/auth.json";
import itAuth from "./locales/it/auth.json";
import esAuth from "./locales/es/auth.json";

import enHome from "./locales/en/home.json";
import deHome from "./locales/de/home.json";
import nlHome from "./locales/nl/home.json";
import frHome from "./locales/fr/home.json";
import itHome from "./locales/it/home.json";
import esHome from "./locales/es/home.json";

import enAppliance from "./locales/en/appliance.json";
import deAppliance from "./locales/de/appliance.json";
import nlAppliance from "./locales/nl/appliance.json";
import frAppliance from "./locales/fr/appliance.json";
import itAppliance from "./locales/it/appliance.json";
import esAppliance from "./locales/es/appliance.json";

import enProfile from "./locales/en/profile.json";
import deProfile from "./locales/de/profile.json";
import nlProfile from "./locales/nl/profile.json";
import frProfile from "./locales/fr/profile.json";
import itProfile from "./locales/it/profile.json";
import esProfile from "./locales/es/profile.json";

import enWorkOrders from "./locales/en/workOrders.json";
import deWorkOrders from "./locales/de/workOrders.json";
import nlWorkOrders from "./locales/nl/workOrders.json";
import frWorkOrders from "./locales/fr/workOrders.json";
import itWorkOrders from "./locales/it/workOrders.json";
import esWorkOrders from "./locales/es/workOrders.json";

import enRepair from "./locales/en/repair.json";
import deRepair from "./locales/de/repair.json";
import nlRepair from "./locales/nl/repair.json";
import frRepair from "./locales/fr/repair.json";
import itRepair from "./locales/it/repair.json";
import esRepair from "./locales/es/repair.json";

import enRefurb from "./locales/en/refurb.json";
import deRefurb from "./locales/de/refurb.json";
import nlRefurb from "./locales/nl/refurb.json";
import frRefurb from "./locales/fr/refurb.json";
import itRefurb from "./locales/it/refurb.json";
import esRefurb from "./locales/es/refurb.json";

import enHarvest from "./locales/en/harvest.json";
import deHarvest from "./locales/de/harvest.json";
import nlHarvest from "./locales/nl/harvest.json";
import frHarvest from "./locales/fr/harvest.json";
import itHarvest from "./locales/it/harvest.json";
import esHarvest from "./locales/es/harvest.json";

import enInventory from "./locales/en/inventory.json";
import deInventory from "./locales/de/inventory.json";
import nlInventory from "./locales/nl/inventory.json";
import frInventory from "./locales/fr/inventory.json";
import itInventory from "./locales/it/inventory.json";
import esInventory from "./locales/es/inventory.json";

import enStore from "./locales/en/store.json";
import deStore from "./locales/de/store.json";
import nlStore from "./locales/nl/store.json";
import frStore from "./locales/fr/store.json";
import itStore from "./locales/it/store.json";
import esStore from "./locales/es/store.json";

import enAdmin from "./locales/en/admin.json";
import deAdmin from "./locales/de/admin.json";
import nlAdmin from "./locales/nl/admin.json";
import frAdmin from "./locales/fr/admin.json";
import itAdmin from "./locales/it/admin.json";
import esAdmin from "./locales/es/admin.json";

import enPassport from "./locales/en/passport.json";
import dePassport from "./locales/de/passport.json";
import nlPassport from "./locales/nl/passport.json";
import frPassport from "./locales/fr/passport.json";
import itPassport from "./locales/it/passport.json";
import esPassport from "./locales/es/passport.json";

import enSettings from "./locales/en/settings.json";
import deSettings from "./locales/de/settings.json";
import nlSettings from "./locales/nl/settings.json";
import frSettings from "./locales/fr/settings.json";
import itSettings from "./locales/it/settings.json";
import esSettings from "./locales/es/settings.json";

export const SUPPORTED_LOCALES = ["en", "de", "nl", "fr", "it", "es"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_LABELS: Record<SupportedLocale, { native: string; flag: string }> = {
  en: { native: "English", flag: "🇬🇧" },
  de: { native: "Deutsch", flag: "🇩🇪" },
  nl: { native: "Nederlands", flag: "🇳🇱" },
  fr: { native: "Français", flag: "🇫🇷" },
  it: { native: "Italiano", flag: "🇮🇹" },
  es: { native: "Español", flag: "🇪🇸" },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: en, auth: enAuth, home: enHome, appliance: enAppliance, profile: enProfile, workOrders: enWorkOrders, repair: enRepair, refurb: enRefurb, harvest: enHarvest, inventory: enInventory, store: enStore, admin: enAdmin, passport: enPassport, settings: enSettings },
      de: { common: de, auth: deAuth, home: deHome, appliance: deAppliance, profile: deProfile, workOrders: deWorkOrders, repair: deRepair, refurb: deRefurb, harvest: deHarvest, inventory: deInventory, store: deStore, admin: deAdmin, passport: dePassport, settings: deSettings },
      nl: { common: nl, auth: nlAuth, home: nlHome, appliance: nlAppliance, profile: nlProfile, workOrders: nlWorkOrders, repair: nlRepair, refurb: nlRefurb, harvest: nlHarvest, inventory: nlInventory, store: nlStore, admin: nlAdmin, passport: nlPassport, settings: nlSettings },
      fr: { common: fr, auth: frAuth, home: frHome, appliance: frAppliance, profile: frProfile, workOrders: frWorkOrders, repair: frRepair, refurb: frRefurb, harvest: frHarvest, inventory: frInventory, store: frStore, admin: frAdmin, passport: frPassport, settings: frSettings },
      it: { common: it, auth: itAuth, home: itHome, appliance: itAppliance, profile: itProfile, workOrders: itWorkOrders, repair: itRepair, refurb: itRefurb, harvest: itHarvest, inventory: itInventory, store: itStore, admin: itAdmin, passport: itPassport, settings: itSettings },
      es: { common: es, auth: esAuth, home: esHome, appliance: esAppliance, profile: esProfile, workOrders: esWorkOrders, repair: esRepair, refurb: esRefurb, harvest: esHarvest, inventory: esInventory, store: esStore, admin: esAdmin, passport: esPassport, settings: esSettings },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LOCALES as unknown as string[],
    nonExplicitSupportedLngs: true, // map "de-DE" → "de"
    defaultNS: "common",
    ns: ["common", "auth", "home", "appliance", "profile", "workOrders", "repair", "refurb", "harvest", "inventory", "store", "admin", "passport", "settings"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "lovable.lng",
      caches: ["localStorage"],
    },
  });

export default i18n;

/** Best-effort: pick a row's per-locale field, fall back to the base column. */
export function tField<T extends Record<string, any>>(
  row: T | null | undefined,
  field: keyof T & string,
  lng?: string,
): any {
  if (!row) return undefined;
  const code = (lng ?? i18n.language ?? "en").split("-")[0];
  const tr = (row as any).translations?.[code]?.[field];
  return tr ?? row[field];
}
